import React from 'react';
import { TColumn } from 'components/tables/Table/types';
import { apiAdminsRead } from 'services/dataFetching/crud';
import moment from 'moment';
import clsx from 'clsx';

export const columns: Array<TColumn> = [
  { Header: 'email', accessor: 'email' },
  {
    Header: 'Full name',
    Cell: ({ row }) => {
      return (
        <>
          {row.first_name} {row.last_name}
        </>
      );
    },
  },
  {
    Header: 'Created at',
    accessor: 'created_at',
    Cell: ({ value }) => {
      return <>{moment(value).format('YYYY/MM/DD HH:mm')}</>;
    },
  },
  {
    Header: 'Status',
    accessor: 'deleted_at',
    tdClassName: '-deletedAt',
    Cell: ({ value }) => {
      const isDeleted =
        moment(value).valueOf() > 0
          ? moment(value).format('DD/MM/YYYY HH:mm')
          : false;

      return (
        <div
          className={clsx('isDeleted', (isDeleted && '--deleted') || '--ok')}
        >
          {isDeleted ? '✖' : `✔`}
        </div>
      );
    },
  },
];

export const tableApiCall = (dispatch?: any) => ({
  apiCall: (body: any) =>
    apiAdminsRead(body).then((r: any) => ({
      data: r.body.admins,
      total: r.body.total,
    })),
});
